// Bahasa Indonesia — the default language and the fallback for any key the
// other dictionaries miss. Keep en.js and ms.js in the same shape.
const id = {
    common: {
        back: 'Kembali',
        close: 'Tutup',
        menu: 'Menu',
        login: 'Masuk',
        redirecting: 'Mengalihkan...',
        sessionExpired: 'Sesi Anda telah berakhir. Silakan masuk kembali.',
        genericError: 'Terjadi kesalahan. Silakan coba lagi.',
        days: '{n} Hari',
        packages: '{n} Paket',
        popular: 'Populer',
        promo: 'Promo',
        topUp: 'Top Up',
        sort: 'Urutkan',
        seeAll: 'Lihat Semua',
    },
    help: {
        title: 'Ada Kendala?',
        desc: 'Tenang, kami siap bantu sampai beres.',
        cta: 'Chat Sekarang',
    },
    nav: {
        shop: 'Toko',
        esim: 'eSIM',
        profile: 'Profil',
    },
    language: {
        label: 'Bahasa',
        choose: 'Pilih Bahasa',
    },
    home: {
        title: 'Terhubung **Tanpa Batas** di Luar Negeri!',
        cta: 'Akses internet cepat di mana saja dengan Arta Mobile!',
        networkText: 'Dapatkan akses ke jaringan terbaik di seluruh dunia',
        networkAria: 'Mitra jaringan kami',
        promoTitle: 'Lagi Promo!',
        prev: 'Sebelumnya',
        next: 'Berikutnya',
        otherPackages: 'Pilihan Paket Lainnya',
        categoryAria: 'Kategori negara',
        tabs: {
            popular: 'Negara Populer',
            umrah: 'Umrah / Haji',
            multi: 'Multi Country',
        },
        openRegion: 'Buka {name}',
        startingFrom: 'Mulai dari',
        loadError: 'Gagal memuat destinasi.',
        retry: 'Coba Lagi',
        empty: 'Tidak ada destinasi pada kategori ini.',
        showLess: 'Lebih Sedikit',
        howTitle: 'No Ribet! Cara Pakai eSIM',
        steps: [
            { title: 'Beli Paket', desc: 'Sesuaikan dengan tujuan' },
            { title: 'Scan QR', desc: 'Instal & aktifkan dalam detik' },
            { title: 'Siap Pakai', desc: 'Nikmati internet di luar negeri' },
        ],
        faqTitle: 'Tanya Jawab',
        faqs: [
            {
                q: 'Apa itu eSIM?',
                a: 'eSIM (embedded SIM) adalah SIM digital yang langsung tertanam di perangkatmu. Kamu bisa mengaktifkan paket data tanpa perlu kartu SIM fisik — cukup scan QR code dan langsung terhubung.',
            },
            {
                q: 'Apakah HP saya mendukung eSIM?',
                a: 'Sebagian besar iPhone (XS ke atas), Samsung Galaxy S20 ke atas, Google Pixel 3 ke atas, dan banyak perangkat Android flagship lainnya sudah mendukung eSIM. Pastikan HP kamu tidak dalam status terkunci operator (carrier lock).',
            },
            {
                q: 'Kapan eSIM mulai aktif?',
                a: 'eSIM aktif otomatis saat pertama kali kamu terhubung ke jaringan di negara tujuan. Jadi tidak perlu khawatir kuota terpakai sebelum kamu benar-benar berangkat.',
            },
            {
                q: 'Apakah saya masih bisa menerima panggilan & SMS dari nomor Indonesia?',
                a: 'Ya, bisa. eSIM Arta Mobile dipasang sebagai SIM kedua. Nomor Indonesia di SIM utamamu tetap aktif untuk terima telepon dan SMS, sementara eSIM digunakan untuk data internet.',
            },
            {
                q: 'Berapa lama masa aktif paket dan apa yang terjadi jika kuota habis?',
                a: 'Masa aktif bervariasi sesuai paket yang kamu pilih (mulai dari 3 hari hingga 30 hari). Jika kuota habis sebelum masa aktif berakhir, koneksi akan berhenti otomatis. Kamu bisa membeli paket baru kapan saja.',
            },
            {
                q: 'Bagaimana jika QR code tidak bisa dipindai?',
                a: 'Pastikan kamu menginstal eSIM saat ada koneksi internet (Wi-Fi). Jika QR code tetap tidak terbaca, kamu bisa memasukkan kode aktivasi secara manual. Hubungi tim kami via WhatsApp jika masih terkendala — kami siap bantu 24/7.',
            },
        ],
        footerDesc: 'Arta Mobile adalah eSIM dari PT. Arta Komunikasi Global yang hadir untuk memudahkan perjalananmu ke luar negeri.',
        followUs: 'Follow Us',
    },
    search: {
        placeholder: 'Cari negara tujuan',
        clear: 'Hapus pencarian',
    },
    region: {
        loading: 'Memuat…',
        loadError: 'Gagal memuat.',
        topbarTitle: '{name} eSIM',
        desc: 'Nikmati konektivitas 5G yang lancar di {name} dengan jaringan lokal kami.',
        pillSpeed: 'Kecepatan 4G/5G',
        pillHotspot: 'Hotspot Tersedia',
        bannerTitle: 'Siap untuk terhubung?',
        bannerSub: 'Cek Ponsel Mendukung eSIM',
        bannerCta: 'Cek Disini',
        packagesTitle: 'Paket yang Tersedia',
        packagesSub: 'Pilih paket data terbaik untuk perjalanan Anda.',
        listView: 'Tampilan list',
        gridView: 'Tampilan grid',
        sortOptions: {
            default: 'Urutan Default',
            'price-asc': 'Harga Termurah',
            'price-desc': 'Harga Termahal',
            'data-desc': 'Data Terbanyak',
            'data-asc': 'Data Terkecil',
        },
        simCardTab: 'SIM Card',
        simCardTitle: 'SIM Card Arab Saudi',
        simCardSub: 'HP kamu tidak support esim? Gunakan SIM Fisik Arta Mobile',
        simCardCta: 'Pesan di Shopee',
        advTitle: 'Keunggulan Layanan Kami',
        advSub: 'Nikmati kemudahan dan kenyamanan menggunakan eSIM kami di {name}.',
        advantages: [
            { title: 'Masa Aktif', desc: 'Otomatis dimulai ketika eSIM terhubung dengan jaringan di negara tujuan' },
            { title: 'Tanpa Registrasi', desc: 'Tanpa perlu KTP atau Paspor' },
            { title: 'Bisa Top Up', desc: 'Tambah kuota dengan mudah di perjalanan' },
        ],
        otherTitle: 'Pilihan Paket Lainnya',
        startingFrom: 'Mulai {price}',
        coverageTitle: 'Jangkauan Negara',
        coverageCount: '{n} negara',
        showLess: 'Tampilkan lebih sedikit',
        showAll: 'Tampilkan semua',
    },
    devices: {
        dialogAria: 'Daftar Device eSIM',
        title: 'Dukungan Perangkat',
        version: 'V. 2.4.0 • UPDATED SEPT 2025',
        searchPlaceholder: 'Cari model perangkatmu...',
        searchAria: 'Cari device',
        clearSearch: 'Hapus pencarian',
        all: 'Semua',
        models: '{n} MODEL',
        others: 'Merek Lainnya',
        emptyTitle: 'Tidak ditemukan',
        emptyDesc: 'Device "{query}" tidak ada dalam daftar kami.',
        reset: 'Reset pencarian',
        noteTitle: 'Perangkat Tidak Terdaftar?',
        noteDesc: 'Perangkat setelah 2021 umumnya mendukung eSIM. Jika tidak terlihat, hubungi dukungan atau periksa pengaturan.',
    },
    payment: {
        title: 'Pembayaran',
        topupTitle: 'Topup eSIM {region}',
        emailTopup: 'Topup eSIM ICCID {iccid}',
        emailNew: 'eSIM Anda akan dikirim ke {email}',
        methodsTitle: 'Metode Pembayaran',
        methods: {
            qris: 'Gopay, Shopeepay, OVO, Dana, LinkAja',
            gopay: 'Bayar instan dengan aplikasi Gopay',
        },
        promoTitle: 'Promo & Voucher',
        promoPlaceholder: 'Masukkan kode promo',
        promoChecking: 'Cek...',
        promoCheck: 'Cek Disini',
        promoApplied: 'Promo **{code}** berhasil diterapkan.',
        promoEmpty: 'Masukkan kode promo terlebih dahulu.',
        promoNotFound: 'Kode promo tidak ditemukan.',
        promoInvalid: 'Kode Promo Tidak Ditemukan',
        consent: 'Dengan menekan tombol bayar, kamu menyetujui Syarat dan Ketentuan dan Kebijakan Privasi artamobile.id',
        total: 'Total Bayar',
        processing: 'Memproses...',
        payNow: 'Bayar Sekarang',
    },
    qris: {
        appbar: 'Menunggu Pembayaran',
        title: 'Selesaikan Pembayaran',
        helper: 'Scan kode QRIS ini menggunakan aplikasi bank Anda. Pembayaran akan terdeteksi otomatis.',
        expired: 'Kode QR Kedaluwarsa',
        expiresIn: 'Berakhir dalam {time}',
        unknownExpiry: 'Waktu kedaluwarsa tidak diketahui',
        noQr: 'Kode QR tidak tersedia.',
        checkStatusAria: 'Cek Status Pembayaran',
        checking: 'Mengecek...',
        checkStatus: 'Cek Status',
        saveToPhotos: 'Simpan ke Foto',
        saveQr: 'Simpan QR Code',
        shareTitle: 'QRIS Pembayaran',
        shareText: 'Simpan gambar ke Foto.',
        statusCreated: 'Status pembayaran belum diterima. Jika sudah bayar, tunggu 1–2 menit lalu cek lagi.',
        statusExpired: 'Kode QR telah kedaluwarsa. Silakan lakukan pembayaran baru.',
        statusOther: 'Status pembayaran: {status}. Silakan tunggu beberapa saat.',
        statusError: 'Gagal mengecek status. Coba lagi.',
        total: 'Total Bayar',
        copyAmount: 'Salin jumlah',
        howTitle: 'Cara Membayar',
        steps: [
            { title: 'Buka Aplikasi', desc: 'Buka aplikasi m-banking atau e-wallet pilihan Anda (Gopay, OVO, Dana, dll).' },
            { title: 'Scan QR Code', desc: "Pilih menu 'Scan' atau 'Bayar' dan arahkan kamera ke kode QR di layar ini." },
            { title: 'Konfirmasi', desc: 'Pastikan nominal sesuai, masukkan PIN, dan transaksi selesai secara otomatis.' },
        ],
    },
    paymentStatus: {
        steps: {
            esim: [
                { title: 'Verifikasi Pembayaran', sub: 'Dikonfirmasi otomatis' },
                { title: 'Membuat eSIM Anda', sub: 'Menghubungkan ke provider global...' },
                { title: 'Kirim ke Email', sub: 'Instruksi akan dikirim ke inbox Anda' },
            ],
            topup: [
                { title: 'Verifikasi Pembayaran', sub: 'Dikonfirmasi otomatis' },
                { title: 'Menambahkan Paket Data', sub: 'Memproses paket data Anda...' },
                { title: 'Paket Data Aktif', sub: 'Kuota akan segera tersedia' },
            ],
        },
        headings: {
            processing: {
                esim: { pill: 'PROSES REAL-TIME', title: 'Penerbitan eSIM Diproses', sub: 'Kami sedang menyiapkan konektivitas Anda. Mohon tunggu sebentar.' },
                topup: { pill: 'PROSES REAL-TIME', title: 'Top Up Sedang Diproses', sub: 'Kami sedang menambahkan paket data Anda. Mohon tunggu sebentar.' },
            },
            success: {
                esim: { pill: 'SELESAI', title: 'Penerbitan eSIM Berhasil', sub: 'eSIM Anda telah diterbitkan dan dikirim ke email Anda.' },
                topup: { pill: 'SELESAI', title: 'Top Up Berhasil', sub: 'Paket data Anda telah berhasil ditambahkan.' },
            },
            failed: {
                esim: { pill: 'GAGAL', title: 'Pembayaran Gagal', sub: 'Maaf, pembayaran tidak dapat diselesaikan. Silakan coba lagi.' },
                topup: { pill: 'GAGAL', title: 'Pembayaran Gagal', sub: 'Maaf, pembayaran tidak dapat diselesaikan. Silakan coba lagi.' },
            },
        },
        orderStatus: 'Status Pesanan',
        orderNotFound: 'Nomor pesanan tidak ditemukan.',
        appbarTopup: 'Top Up',
        appbarEsim: 'Penerbitan eSIM',
        backHome: 'Kembali ke Beranda',
        viewEsims: 'Lihat eSIM Saya',
        retry: 'Coba Lagi',
    },
    esims: {
        title: 'My SIM',
        loadingAria: 'Memuat eSIM Anda',
        active: 'Aktif',
        archived: 'Arsip',
        count: '{n} eSIM',
        newest: 'Terbaru',
        oldest: 'Terlama',
        loadError: 'Terjadi kesalahan saat memuat eSIM.',
        buyNew: 'Beli eSIM baru',
        loginTitle: 'Masuk untuk Melihat eSIM Anda',
        loginDesc: 'Simpan dan kelola semua paket data perjalanan Anda dalam satu tempat yang aman.',
        emptyActiveTitle: 'Belum Ada eSIM Aktif',
        emptyActiveDesc: 'Mulai petualanganmu dengan memilih paket data terbaik untuk perjalananmu berikutnya.',
        emptyArchiveTitle: 'Arsip Kosong',
        emptyArchiveDesc: 'eSIM yang sudah tidak aktif atau tidak digunakan lagi akan muncul di sini agar My SIM aktifmu tetap rapi.',
        topupTitle: 'Tambah Kuota',
        topupSubtitle: 'Pilih kuota yang ingin ditambahkan ke eSIM Anda',
    },
    esimCard: {
        status: {
            created: 'Siap Aktivasi',
            inUse: 'Aktif',
            usedUp: 'Kuota Habis',
            expired: 'Expired',
            cancelled: 'Dibatalkan',
        },
        iccid: 'ICCID: {iccid}',
        purchased: 'Tgl. Beli: {date}',
        checkQuota: 'Cek Kuota',
    },
    topupModal: {
        title: 'Tambah Kuota',
        subtitle: 'Pilih paket kuota yang ingin Anda tambahkan.',
        empty: 'Belum ada paket top up yang tersedia.',
        validity: 'Berlaku {n} hari',
    },
    esimDetail: {
        loadError: 'Gagal memuat eSIM. Silakan coba lagi.',
        planStatus: {
            active: 'Aktif',
            terminated: 'Berakhir',
            notActive: 'Ready to Install',
        },
        sorts: {
            'price-asc': 'Harga Terendah',
            'price-desc': 'Harga Tertinggi',
            'data-asc': 'Kuota Terkecil',
            'data-desc': 'Kuota Terbesar',
        },
        validUntil: 'Berlaku sampai',
        useBefore: 'Gunakan Sebelum',
        shareTitle: '{label} — Arta Mobile',
        shareText: 'Detail {label} di Arta Mobile',
        linkCopied: 'Link disalin ke clipboard',
        linkCopyFailed: 'Gagal menyalin link',
        rename: 'Ubah Nama',
        share: 'Bagikan',
        sendEmail: 'Kirim email',
        archive: 'Arsipkan',
        archiveWait: 'Tunggu refund selesai',
        refundStatus: 'Status refund',
        requestRefund: 'Ajukan refund',
        refundChecking: 'Memeriksa…',
        refundBanner: {
            review: { title: 'Refund sedang ditinjau CS', sub: 'Maks. {sla}. eSIM masih bisa dipakai selama ditinjau.' },
            processing: { title: 'Refund sedang diproses', sub: 'Dana dikembalikan ke metode bayar asal.' },
            done: { title: 'Refund selesai', sub: 'Dana sudah dikembalikan ke metode bayar asal.' },
            rejected: { title: 'Refund ditolak', sub: 'Lihat alasannya di status refund.' },
        },
        installTitle: 'Panduan Pemasangan eSIM',
        installSub: 'Aktifkan eSIM di perangkat Anda',
        tabQuota: 'Kuota',
        tabHistory: 'Riwayat',
        gbLeft: 'GB LEFT',
        usedData: 'USED DATA',
        totalData: 'TOTAL DATA',
        noHistory: 'Belum ada riwayat paket.',
        validity: 'Masa Aktif',
        quota: 'Kuota',
        ends: 'Berakhir',
        warningTitle: 'Perhatian!',
        warningBody: 'Jangan menghapus eSIM. eSIM yang dihapus tidak dapat dipasang lagi.',
        topupTitle: 'Isi Ulang Paketmu',
    },
    esimLegacy: {
        loading: 'Loading...',
        warningBody: 'Jangan Menghapus eSIM, eSIM yang dihapus tidak dapat diinstall lagi',
        install: 'Instruksi Pemasangan eSIM',
        usage: 'USAGE',
        remaining: 'REMAINING DATA',
        expires: 'Expires',
        myPackages: 'MY PACKAGES',
        expiry: 'Expiry',
        validity: 'Validity',
        days: '{n} Days',
        data: 'Data',
        status: {
            ACTIVE: 'Active',
            TERMINATED: 'Expired',
            NOT_ACTIVE: 'Non-Active',
        },
        renameAria: 'Ubah nama eSIM',
        menuAria: 'Tampilkan menu',
        rename: 'Ganti Nama',
        shareEmail: 'Bagikan via Email',
        archive: 'Arsipkan eSIM',
        country: 'Negara',
        sharedWith: 'Dibagikan',
        topupHeader: 'TOP UP',
        topupAria: 'Pilihan top up',
        topupCta: 'Top up',
    },
    renameModal: {
        title: 'Ubah nama eSIM',
        info: 'Ini hanya mengubah nama eSIM di aplikasi — tidak mengubah nama di pengaturan perangkat Anda.',
        label: 'Nama eSIM',
        remaining: '{n} karakter tersisa.',
        saving: 'Menyimpan…',
        submit: 'Ubah nama eSIM',
        success: 'Nama eSIM berhasil diperbarui!',
        failed: 'Gagal memperbarui nama eSIM. Coba lagi.',
    },
    shareModal: {
        title: 'Bagikan via Email',
        info: 'Kirim detail eSIM (termasuk kode aktivasi) ke alamat email penerima.',
        label: 'Email penerima',
        placeholder: 'nama@contoh.com',
        invalid: 'Alamat email tidak valid.',
        sending: 'Mengirim…',
        send: 'Kirim',
        success: 'Berhasil mengirim informasi eSIM ke email penerima.',
        failed: 'Gagal mengirim email. Coba lagi.',
    },
    archiveModal: {
        title: 'Arsipkan eSIM?',
        body: 'eSIM yang diarsipkan tidak akan muncul di daftar utama, tetapi data historis masih tersimpan di sistem.',
        confirmQuestion: 'Anda yakin ingin mengarsipkan eSIM ini?',
        cancel: 'Batal',
        archiving: 'Mengarsipkan…',
        confirm: 'Arsipkan eSIM',
        success: 'eSIM berhasil diarsipkan.',
        failed: 'Gagal mengarsipkan eSIM. Coba lagi.',
    },
    review: {
        title: 'Ulasan Anda',
        body: 'Bantu kami menjaga kualitas jaringan di setiap tujuan.',
        questionRegion: 'Bagaimana koneksi di {region}?',
        question: 'Bagaimana koneksi?',
        submitError: 'Gagal mengirim ulasan. Coba lagi.',
        doneAria: 'Ulasan Anda {n} dari 5',
        thanks: 'Terima kasih atas ulasan Anda.',
        star: '{n} bintang',
        placeholder: 'Tulis komentar Anda (opsional)',
        sending: 'Mengirim…',
        submit: 'Kirim ulasan',
    },
    installCard: {
        stages: {
            NOT_STARTED: {
                title: 'eSIM belum terpasang',
                body: 'Pasang eSIM sebelum berangkat. Prosesnya hanya butuh beberapa menit dan koneksi internet.',
            },
            STALLED: {
                title: 'Pemasangan belum selesai',
                body: 'Pemasangan eSIM Anda terhenti di tengah jalan. Silakan coba pasang ulang.',
            },
            INSTALLED: {
                title: 'eSIM sudah terpasang',
                body: 'Jangan lupa aktifkan data roaming di pengaturan HP kamu.',
            },
            DELETED: {
                title: 'Profil eSIM terhapus dari perangkat',
                body: 'Profil eSIM ini sudah tidak ada di HP Anda.',
            },
        },
        question: 'Bagaimana proses pemasangan eSIM ini?',
    },
    install: {
        appbar: 'Pilih Metode',
        tabsAria: 'Mode pemasangan',
        tabs: {
            instant: 'Instan',
            qr: 'Scan QR',
            manual: 'Manual',
        },
        wifiWarn: 'Pastikan handphone terhubung dengan internet stabil saat melakukan instalasi eSIM.',
        notIos: 'Fitur pemasangan instan hanya tersedia di **iPhone**. Gunakan metode **Scan QR** atau **Manual**.',
        oldIos: 'Fitur pemasangan instan hanya tersedia pada **iOS 17.4** keatas. Gunakan metode **Scan QR** atau **Manual**.',
        detected: 'Perangkat Terdeteksi',
        unknownOs: 'OS tidak dikenal',
        step1: 'Langkah 1/2 — Install eSIM',
        step2: 'Langkah 2/2 — Nyalakan Roaming',
        instantStep: 'Install eSIM Menggunakan tombol di bawah',
        roaming1: 'Aktifkan **Data Roaming**.',
        roaming2: 'Set eSIM sebagai paket **Data Seluler** saat di negara tujuan.',
        installBtn: 'Pasang eSIM di iPhone ini',
        qrLead1: 'Scan QR dibawah pada handphone',
        qrLead2: 'yang akan memakai eSIM',
        qrAlt: 'QR untuk instalasi eSIM',
        qrIphone: '**iPhone**: Pengaturan → Data Seluler → Tambahkan eSIM → Gunakan Kode QR',
        qrAndroid: '**Android**: Pengaturan → Koneksi/Jaringan → SIM Manager → Tambahkan eSIM → Gunakan QR',
        smdp: 'Alamat SM-DP+',
        activationCode: 'Kode Aktivasi',
        copy: 'Salin',
        copied: 'Tersalin',
        manualIphone: '**iPhone**: Pengaturan → Data Seluler → Tambahkan eSIM → **Masukkan Detail Manual** (isi Alamat SM-DP+ dan Kode Aktivasi di atas)',
        manualAndroid: '**Android**: Pengaturan → Koneksi/Jaringan → SIM Manager → Tambahkan eSIM → **Masukkan Kode**',
        copyFailed: 'Gagal menyalin – silakan salin manual.',
        iphoneOnly: 'Fitur ini hanya tersedia di iPhone.',
        confirm: 'Pasang eSIM pada iPhone ini sekarang?',
    },
    kuota: {
        loadingAria: 'Memuat',
        loginTitle: 'Masuk untuk Cek Kuota',
        loginDesc: 'Masuk ke akun Arta Mobile Anda terlebih dahulu untuk memeriksa sisa kuota kartu SIM.',
        linkingAria: 'Menghubungkan kartu SIM',
        linking: 'Menghubungkan kartu SIM ke akun Anda…',
        scanTitle: 'Pindai Barcode',
        scanDesc: 'Arahkan kamera ke barcode pada kemasan kartu SIM Anda.',
        cancel: 'Batal',
        introTitle: 'Cek Kuota Kartu SIM',
        introDesc: 'Pindai barcode yang tertera pada kemasan kartu SIM untuk menghubungkannya ke akun Anda dan melihat sisa kuota.',
        scanBtn: 'Pindai Barcode',
        hideManual: 'Sembunyikan input manual',
        showManual: 'Masukkan nomor ICCID manual',
        iccidLabel: 'Nomor ICCID',
        checkQuota: 'Cek Kuota',
        errors: {
            unrecognized: 'Nomor ICCID tidak dikenali. Coba pindai ulang atau masukkan manual.',
            unverified: 'Akun Anda belum terverifikasi. Verifikasi email Anda terlebih dahulu.',
            notFound: 'Kartu SIM tidak ditemukan. Pastikan barcode pada kemasan terpindai dengan benar.',
            linkFailed: 'Gagal menghubungkan kartu SIM. Silakan coba lagi.',
            camera: 'Kamera tidak dapat diakses. Izinkan akses kamera di pengaturan browser, atau masukkan nomor ICCID secara manual.',
        },
    },
    profile: {
        loginTitle: 'Masuk untuk Mengakses Profil',
        loginDesc: 'Kelola akun dan preferensi Anda dalam satu tempat.',
        userFallback: 'Pengguna',
        avatarAlt: 'Profil',
        preferences: 'Preferensi',
        currency: 'Mata Uang',
        currencyValue: 'IDR - Rupiah',
        support: 'Dukungan',
        contact: 'Hubungi Kami',
        logout: 'Keluar',
    },
    refund: {
        slaLabel: '3×24 jam',
        reasons: {
            TRIP_CANCELLED: 'Batal bepergian',
            WRONG_PACKAGE: 'Salah pilih negara atau paket',
            DEVICE_NOT_SUPPORTED: 'HP tidak mendukung eSIM',
            OTHER: 'Lainnya',
        },
        ineligible: {
            ESIM_IN_USE: 'eSIM sudah aktif',
            WINDOW_EXPIRED: 'Lewat 30 hari sejak pembelian',
            NOT_SELF_SERVICE: 'Hubungi CS untuk refund',
            PROVIDER_UNAVAILABLE: 'Sedang tidak bisa dicek, coba lagi nanti',
        },
        status: {
            review: 'Ditinjau CS',
            done: 'Selesai',
            rejected: 'Ditolak',
            processing: 'Diproses',
        },
        payment: {
            credit_card: 'kartu kredit',
            bank_transfer: 'transfer bank',
        },
        request: {
            title: 'Ajukan refund',
            checking: 'Memeriksa eSIM…',
            forbiddenTitle: 'Refund hanya bisa diajukan pembeli',
            forbiddenBody: 'Masuk dengan email yang dipakai saat membeli eSIM ini, atau hubungi CS.',
            errorTitle: 'Gagal memeriksa eSIM',
            errorBody: 'Coba lagi beberapa saat lagi.',
            retry: 'Coba lagi',
            notEligibleTitle: 'Belum bisa refund',
            notEligibleDefault: 'eSIM ini tidak memenuhi syarat refund.',
            contactCs: 'Hubungi CS kalau ada kendala.',
            chatCs: 'Chat CS via WhatsApp',
            eligibleTitle: 'Memenuhi syarat refund',
            eligibleBody: 'Tim CS meninjau maks. {sla}. Dana kembali otomatis ke metode bayar asal, tanpa isi data rekening.',
            reasonLegend: 'Alasan refund',
            note: 'Catatan',
            optional: '(opsional)',
            notePlaceholder: 'Ceritakan singkat kendalamu',
            validity: 'Masa aktif {n} hari',
            footerNote: 'Jika disetujui, eSIM dinonaktifkan dan tidak bisa dipakai lagi.',
            sending: 'Mengirim…',
            networkError: 'Koneksi bermasalah. Coba lagi.',
            submitError: 'Gagal mengirim pengajuan. Coba lagi atau hubungi CS.',
        },
        statusPage: {
            title: 'Status refund',
            loading: 'Memuat status refund…',
            forbidden: 'Status refund hanya bisa dilihat pembeli eSIM ini.',
            loadError: 'Gagal memuat status refund.',
            retry: 'Coba lagi',
            none: 'Belum ada pengajuan refund untuk eSIM ini.',
            request: 'Ajukan refund',
            toOriginal: 'ke metode bayar asal',
            askCs: 'Tanya CS via WhatsApp',
            steps: {
                received: 'Pengajuan diterima',
                reviewed: 'Ditinjau tim CS',
                reviewSub: 'Maks. {sla}. eSIM masih bisa dipakai selama ditinjau.',
                deactivated: 'eSIM dinonaktifkan',
                refunded: 'Dana dikembalikan',
                refundedSub: 'Waktu masuk tergantung bank atau e-wallet',
                rejected: 'Ditolak',
            },
        },
    },
};

export default id;
